import { render, staticRenderFns } from "./Property-barcode.vue?vue&type=template&id=51010538&"
import script from "./Property-barcode.vue?vue&type=script&lang=js&"
export * from "./Property-barcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports